import PercentIcon from '@mui/icons-material/Percent';
import { SvgIconProps } from '@mui/material';
import { BenefitDTOBenefitEnum } from 'probonio-shared-ui/api';
import React from 'react';
import { BenefitMetadataExtensionInterface } from '../../../../extension/interface/benefit-metadata.extension.interface';

export class DiscountCodeBenefitMetadataExtension extends BenefitMetadataExtensionInterface {
  benefitId: BenefitDTOBenefitEnum = BenefitDTOBenefitEnum.DiscountCode;
  get Icon(): React.ComponentType<SvgIconProps> {
    return PercentIcon;
  }
}
